import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationES from './locales/es.json';
import translationEN from './locales/en.json';
import translationCL from './locales/cl.json';
import translationCA from './locales/ca.json';
import translationGL from './locales/gl.json';
import translationDE from './locales/de.json';
import translationFR from './locales/fr.json';
import translationPT from './locales/pt.json';

// The translations. Mismos ocho idiomas que sporttia-competitions.
const resources = {
    es: {
        translation: translationES,
    },
    en: {
        translation: translationEN,
    },
    cl: {
        translation: translationCL,
    },
    ca: {
        translation: translationCA,
    },
    gl: {
        translation: translationGL,
    },
    de: {
        translation: translationDE,
    },
    fr: {
        translation: translationFR,
    },
    pt: {
        translation: translationPT,
    },
};

i18n
    // Detect user language
    .use(LanguageDetector)
    // Pass the i18n instance to react-i18next
    .use(initReactI18next)
    // Init i18next
    .init({
        resources,
        fallbackLng: 'es',
        debug: false,
        interpolation: {
            escapeValue: false, // React already safes from XSS
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: 'lang',
        },
    });

const syncDocumentLang = (lng: string) => {
    if (typeof document !== 'undefined') {
        document.documentElement.lang = lng.split('-')[0] ?? lng;
    }
};

syncDocumentLang(i18n.resolvedLanguage ?? i18n.language ?? 'es');
i18n.on('languageChanged', syncDocumentLang);

export default i18n;
